import { CustomDrillTipModalComponent } from './custom-drill-tip-modal/custom-drill-tip-modal.component';
import { NgModule } from '@angular/core';
import {
  ButtonV2Module,
  CheckboxV2Module,
  IconV2Module,
  InputV2Module,
  ModalModule,
  PipesModule,
  RadioV2Module,
  SpinnerModule,
} from '@schenck/rotec-components';
import { AddMachineModalComponent } from './add-machine-modal/add-machine-modal.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { DeleteRotorTypeModalComponent } from './delete-rotor-type-modal/delete-rotor-type-modal.component';
import { DuplicateRotorModalComponent } from './duplicate-rotor-modal/duplicate-rotor-modal.component';
import { AddEditLocationModalComponent } from './add-edit-location-modal/add-edit-location-modal.component';
import { DuplicateLocationModalComponent } from './duplicate-location/duplicate-location.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RollerbedInfoModalComponent } from './rollerbed-info-modal/rollerbed-info-modal.component';
import { IsoCalcualtionInfoModalComponent } from './iso-calculation-info-modal/iso-calculation-info-modal.component';
import { DuplicateMethodModalComponent } from './duplicate-method/duplicate-method.component';
import { ChangingSupportSettingsModal } from './changing-support-settings-modal/changing-support-settings-modal';
import { WeightSetsModalComponent } from './weight-sets-modal/weight-sets-modal.component';

@NgModule({
  imports: [
    ModalModule.forRoot(),
    TranslatePipe,
    TranslateDirective,
    ButtonV2Module,
    InputV2Module,
    RadioV2Module,
    CheckboxV2Module,
    SpinnerModule.forRoot(),
    CommonModule,
    IconV2Module,
    ReactiveFormsModule,
    PipesModule,
    AddMachineModalComponent,
    DeleteRotorTypeModalComponent,
    DuplicateRotorModalComponent,
    AddEditLocationModalComponent,
    DuplicateLocationModalComponent,
    CustomDrillTipModalComponent,
    RollerbedInfoModalComponent,
    IsoCalcualtionInfoModalComponent,
    DuplicateMethodModalComponent,
    ChangingSupportSettingsModal,
    WeightSetsModalComponent,
  ],
  exports: [
    AddMachineModalComponent,
    DeleteRotorTypeModalComponent,
    DuplicateRotorModalComponent,
    AddEditLocationModalComponent,
    DuplicateLocationModalComponent,
    CustomDrillTipModalComponent,
    IsoCalcualtionInfoModalComponent,
    DuplicateMethodModalComponent,
    ChangingSupportSettingsModal,
    WeightSetsModalComponent,
  ],
})
export class ModalsModule {}
